
import { defineComponent } from "vue"
import api from "../../services/api"

export default defineComponent({
  async mounted() {
    await this.logout()
  },
  methods: {
    async logout() {
      await api.logout()
    }
  }
})
